import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { hexToPastel } from '../../../stylesSheets';

// Dictionary of method colors using theme palette keys (not hardcoded hex colors)
const METHOD_COLORS_DICT = {
  GET: 'info',      // maps to theme.palette.info
  POST: 'success',  // maps to theme.palette.success
  PUT: 'warning',   // maps to theme.palette.warning
  DELETE: 'error',  // maps to theme.palette.error
  PATCH: 'secondary', // maps to theme.palette.secondary
};

export default function MethodChip({ method, size = 'small', sx = {} }) {
  const theme = useTheme();
  
  // Use the dictionary to resolve the palette color. 
  // Never hardcode raw hex values.
  const paletteKey = METHOD_COLORS_DICT[method.toUpperCase()] || 'grey';
  const baseColor = theme.palette[paletteKey]?.main || '#9e9e9e';

  let pastelBg = '#f5f5f5';
  try {
    pastelBg = hexToPastel(baseColor);
  } catch (error) {
    pastelBg = baseColor;
  }

  // Get a matching readable text color.
  const textColor = theme.palette[paletteKey]?.dark || theme.palette.text.primary;

  return (
    <Chip
      label={method}
      size={size}
      sx={{
        backgroundColor: pastelBg,
        color: textColor,
        fontWeight: 'bold',
        fontSize: '0.7rem',
        borderRadius: '4px',
        border: '1px solid',
        borderColor: baseColor,
        opacity: 0.9,
        ...sx,
      }}
    />
  );
}
